import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetWoodCertificationDetailsInputDto, WoodCertificationDetailCreateDto, WoodCertificationDetailDto, WoodCertificationDetailExcelDownloadDto, WoodCertificationDetailUpdateDto } from '../dtos/wood-certification-detail/models';

@Injectable({
  providedIn: 'root',
})
export class WoodCertificationDetailService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: WoodCertificationDetailCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailDto>({
      method: 'POST',
      url: '/api/geographic/woodCertificationDetails',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/woodCertificationDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/woodCertificationDetails',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailDto>({
      method: 'GET',
      url: `/api/geographic/woodCertificationDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetails/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWoodCertificationDetailsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WoodCertificationDetailDto>>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetails',
      params: { woodCertificationId: input.woodCertificationId, woodCertificationName: input.woodCertificationName, locationId: input.locationId, contractId: input.contractId, lastCheckDate: input.lastCheckDate, lastCheckDateFrom: input.lastCheckDateFrom, lastCheckDateTo: input.lastCheckDateTo, addedDate: input.addedDate, addedDateFrom: input.addedDateFrom, addedDateTo: input.addedDateTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: WoodCertificationDetailExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/woodCertificationDetails/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, woodCertificationId: input.woodCertificationId, woodCertificationName: input.woodCertificationName, locationId: input.locationId, contractId: input.contractId, lastCheckDate: input.lastCheckDate, lastCheckDateFrom: input.lastCheckDateFrom, lastCheckDateTo: input.lastCheckDateTo, addedDate: input.addedDate, addedDateFrom: input.addedDateFrom, addedDateTo: input.addedDateTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailDto[]>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetails/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: WoodCertificationDetailUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailDto>({
      method: 'PUT',
      url: `/api/geographic/woodCertificationDetails/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}